import './CardMultipleCard.css';
import React from 'react';
import RouterLink from '../../../atoms/RouterLink';
import { get } from '../../../../utils/getPropertyByPath';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
const CardMultipleCard = _ref => {
  let {
    cardIcon,
    title,
    description,
    ctaLabel,
    ctaLink,
    titleAnalytics,
    ctaAnalytics,
    analyticsHandler
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const titleValue = get(title, "jss.value");
  const descriptionValue = get(description, "jss.value");
  const ctaLabelValue = get(ctaLabel, "jss.value");
  const cardIconSrcValue = get(cardIcon, "jss.value.src");
  const cardIconAltValue = get(cardIcon, "jss.value.alt");
  const ctaLinkHrefValue = get(ctaLink, "jss.value.href");
  const titleEnValue = get(titleAnalytics, "jss.value");
  const ctaLabelEnValue = get(ctaAnalytics, "jss.value");
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "cardWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "imageWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    className: "image",
    src: cardIconSrcValue,
    alt: cardIconAltValue
  })), /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, titleValue), /*#__PURE__*/React.createElement("p", {
    className: "description ellipsis"
  }, descriptionValue), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLinkHrefValue,
    onClick: () => analyticsHandler([titleEnValue, ctaLabelEnValue])
  }, /*#__PURE__*/React.createElement("p", {
    className: "ctaText"
  }, ctaLabelValue))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  const props = {
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles}`,
    children
  };
  return /*#__PURE__*/React.createElement("div", props);
};
const commonStyles = "cqs8tc1";
const ltrStyles = "l1eoflqk";
const rtlStyles = "r1ygyvnr";
export { CardMultipleCard };